// Keyboard helpers shared by the top bar, the command palette, the
// shortcuts list and the global shortcut handler.

/** True on a Mac (or iPad with a keyboard), where the modifier is ⌘. */
export function isMac() {
  if (typeof navigator === "undefined") return false;
  const p = navigator.userAgentData?.platform || navigator.platform || navigator.userAgent || "";
  return /mac|iphone|ipad|ipod/i.test(p);
}

/** The label of the palette's modifier key: ⌘ on a Mac, Ctrl elsewhere. */
export function modKeyLabel() {
  return isMac() ? "⌘" : "Ctrl";
}

/** True when a key press is meant for a field the user is typing in. */
export function isTypingTarget(el) {
  if (!el || !el.tagName) return false;
  const tag = el.tagName;
  if (tag === "TEXTAREA" || tag === "SELECT") return true;
  if (tag === "INPUT") {
    const type = (el.getAttribute("type") || "text").toLowerCase();
    return !["checkbox", "radio", "button", "submit", "reset", "file", "range", "color"].includes(type);
  }
  return Boolean(el.isContentEditable);
}
